<template>
    <div id="simulator">
        <section class="section mb--80">
            <div class="container">
                <div class="section-heading heading-left">
                    <span class="subtitle bold primary">Simulador</span>
                    <h2 class="title">Descubre cuánto puedes <span class="bold">ganar.</span></h2>
                </div>
                <div class="row">
                    <div class="col-12">
                        <ul class="nav nav-underline" id="myTab" role="tablist">
                            <li class="nav-item" role="presentation">
                                <a class="nav-link active" id="compound-tab" data-bs-toggle="tab"
                                    data-bs-target="#compound-tab-pane" type="button" role="tab"
                                    aria-controls="compound-tab-pane" aria-selected="false">Interés compuesto</a>
                            </li>
                            <li class="nav-item" role="presentation">
                                <a class="nav-link" id="passive-tab" data-bs-toggle="tab"
                                    data-bs-target="#passive-tab-pane" type="button" role="tab"
                                    aria-controls="passive-tab-pane" aria-selected="true">Ingreso pasivo</a>
                            </li>
                        </ul>

                        <div class="tab-content" id="myTabContent">
                            <div class="tab-pane fade show active" id="compound-tab-pane" role="tabpanel"
                                aria-labelledby="compound-tab" tabindex="0">
                                <CompoundInterestSimulator />
                            </div>
                            <div class="tab-pane fade" id="passive-tab-pane" role="tabpanel"
                                aria-labelledby="passive-tab" tabindex="1">
                                <PassiveIncomeSimulator />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import CompoundInterestSimulator from './partials/CompoundInterestSimulator.vue';
import PassiveIncomeSimulator from './partials/PassiveIncomeSimulator.vue';

    export default {
    data: () => ({
        drawer: true,
        drawerRight: true,
        right: null,
        left: null
    }),
    props: {
        source: String
    },
    components: { CompoundInterestSimulator, PassiveIncomeSimulator }
}
</script>